<div class="kt-portlet kt-portlet--responsive-mobile">
  <div class="kt-portlet__head">
    <div class="kt-portlet__head-label">
      <h2 class="kt-portlet__head-title text-capitalize">Defectives</h2>
    </div>
  </div>
  <div class="kt-portlet__body" id="scroll-top-pagination">
    <ng-template #sort let-order="order" let-field="field">
      <div class="pull-right sort">
        <i
          class="fas fa-sort"
          *ngIf="!field || !order || order.indexOf(field) < 0"
        ></i>
        <i class="fas fa-sort-up" *ngIf="order == field"></i>
        <i class="fas fa-sort-down" *ngIf="order == '-' + field"></i>
      </div>
    </ng-template>

    <div class="kt-widget filter">
      <div class="form-row">
        <div class="form-group col-md-auto col-sm-auto">
          <label for="">Reported Date From</label>
          <input
            type="date"
            class="form-control"
            [(ngModel)]="filter.date"
            [min]="minDate"
            [max]="maxDate"
            debounceKeyUp
            [debounceTime]="debounceTime"
            (onEvent)="validateDate('date')"
            (keyup.enter)="getRecords(false, 1)"
            (change)="getRecords(false, 1)"
          />
        </div>
        <div class="form-group col-md-auto col-sm-auto">
          <label for="">Reported Date To</label>
          <input
            type="date"
            class="form-control"
            [(ngModel)]="filter.date_to"
            [min]="minDate"
            [max]="maxDate"
            debounceKeyUp
            [debounceTime]="debounceTime"
            (onEvent)="validateDate('date_to')"
            (keyup.enter)="getRecords(false, 1)"
            (change)="getRecords(false, 1)"
          />
        </div>

        <div class="form-group col-md-auto col-sm-auto">
          <label for="">SKU</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="filter.sku"
            (keyup.enter)="getRecords(false, 1)"
          />
        </div>
        <div class="form-group col-md-auto col-sm-auto">
          <label for="">Purchase Order No.</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="filter.po_number"
            (keyup.enter)="getRecords(false, 1)"
          />
        </div>
        <div class="form-group col-md-auto col-sm-auto">
          <label for="">Defect Type</label>
          <select
            name="defect_type"
            class="form-control"
            [(ngModel)]="filter.defect_type"
            (change)="getRecords(false, 1)"
          >
            <option value="0">All Types</option>
            <option
              *ngFor="let dt of defectiveReportSvc.defectTypes"
              [value]="dt.id"
            >
              {{ dt.label }}
            </option>
          </select>
        </div>

        <div
          class="form-group col-md-auto col-sm-auto factory"
          *ngIf="factorySvc.factory$ | async as factories"
        >
          <label for="">Factory</label>
          <ng-select
            [items]="factories"
            bindLabel="factory_name"
            bindValue="id"
            [multiple]="false"
            [(ngModel)]="filter.factory_id"
            (change)="getRecords(false, 1)"
          >
          </ng-select>
        </div>
      </div>
    </div>

    <div class="kt-widget filter">
      <div class="form-row col-md-auto col-sm-auto">
        <div class="form-group">
          <br />
          <button
            class="btn btn-outline-info btn-sm btn-reset"
            (click)="resetFilters()"
          >
            <i class="fas fa-eraser"></i> Reset Filters
          </button>
        </div>

        <div ngbDropdown class="d-inline-block mr-2">
          <br />
          <button
            class="btn btn-outline-primary btn-sm"
            id="dropdownBasic1"
            ngbDropdownToggle
          >
            <span>Export DRs </span>
            <i class="fas fa-caret-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="action-button">
            <button ngbDropdownItem (click)="exportListToPdf()">
              <i class="fas fa-file-pdf"></i> Export to PDF
            </button>
            <button ngbDropdownItem (click)="exportListToCsv()">
              <i class="fas fa-file-csv"></i> Export to CSV
            </button>
          </div>
        </div>

        <div class="form-group">
          <br />
          <button class="btn btn-info btn-sm" (click)="openDefectiveForm()">
            <i class="fas fa-plus"></i> New Defective Report
          </button>
        </div>
      </div>
    </div>

    <div class="overflow-auto">
      <table class="table table-striped table-hover">
        <thead>
          <tr
            *ngIf="
              !defectiveReportSvc.gettingRecords &&
              ordersRecord.data &&
              ordersRecord.data.length > 0
            "
          >
            <td colspan="6" class="totals text-right" align="right">
              <div class="form-inline">
                <div class="form-group mr-5">
                  <label for="">Total UNITS: </label>
                  <span class="form-control">
                    {{ totals.quantity | decimalPlaces }}
                  </span>
                </div>
                <div class="form-group">
                  <label for="">Total COST: </label>
                  <span class="form-control">
                    {{ totals.total | lumCurrency }}
                  </span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th width="130">Reported Date</th>
            <th>Defect Type</th>
            <th>Reported By</th>
            <th>SKUs/Products</th>
            <th class="text-right">Total Units</th>
            <th class="text-right">Total Cost</th>
            <th class="text-center" *ngIf="authService.loginUser.role != 2">
              &nbsp;
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="defectiveReportSvc.gettingRecords">
            <td colspan="6" class="text-center">
              <br />
              <h6 [translate]="'GENERAL.GETTING_RECORDS'">
                <i class="fas fa-spinner fa-spin"></i> Getting records...
              </h6>
              <br />
            </td>
          </tr>
          <tr
            *ngIf="
              !defectiveReportSvc.gettingRecords &&
              ordersRecord.data &&
              ordersRecord.data.length == 0
            "
          >
            <td colspan="6" class="text-center">
              <br />
              <h6 class="text-warning">No record found.</h6>
              <br />
            </td>
          </tr>
          <tr *ngFor="let r of ordersRecord.data; let i = index">
            <td>{{ r.reported_date | date: 'mediumDate' }} <br /></td>
            <td>{{ getDefectType(r.defect_type) }} {{ r.id }}</td>
            <td>
              <div *ngIf="r.reported_by">
                {{ r.reported_by }}
                <small *ngIf="r.reported_at"> [{{ r.reported_at }}]</small>
              </div>
            </td>

            <td>
              <div class="rr-items">
                <span *ngFor="let item of r.defective_report_rfq">
                  <span
                    class="
                      kt-badge kt-badge--default kt-badge-sm kt-badge--outline kt-badge--pill
                    "
                  >
                    <span *ngIf="!item.purchase_order_rfq">{{
                      item.product_name
                    }}</span>
                    <span *ngIf="item.purchase_order_rfq">
                      {{ item.purchase_order_rfq.internal_sku }}
                      <small>
                        {{ item.purchase_order_rfq.product_name }}
                      </small>
                    </span>
                    [<span class="qty">
                      <i
                        >{{ item.unit_price | lumCurrency }}x{{
                          item.quantity | decimalPlaces
                        }}</i
                      >
                    </span>
                    {{
                      item?.purchase_order_rfq?.ordered_uom_id
                        | uomDisplay
                          : item?.purchase_order_rfq?.rfq?.unit_of_measures
                    }}
                    <b> {{ item.line_total | lumCurrency }} </b>]
                  </span>
                </span>
              </div>
            </td>

            <td class="text-right">
              <b>{{ r.total_quantity | decimalPlaces }}</b>
            </td>
            <td class="text-right">
              <b>{{ r.total_cost | lumCurrency }}</b>
            </td>
            <td
              *ngIf="authService.loginUser.role != 2"
              class="flex justify-end position-sticky"
              style="right: 0"
            >
              <button
                mat-icon-button
                [matMenuTriggerFor]="menuActions"
                (click)="$event.stopPropagation()"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
            </td>
            <mat-menu #menuActions="matMenu">
              <button (click)="defectiveReportSvc.exportRFQtoPDF(r)" mat-menu-item>
                <i class="fas fa-file-pdf"></i> Export to PDF
              </button>
              <button (click)="deleteDefectiveReport(r)" mat-menu-item>
                <i class="fas fa-trash text-danger"></i> Delete
              </button>
            </mat-menu>
          </tr>
        </tbody>
        <tfoot *ngIf="totals && totals.quantity">
          <tr>
            <td colspan="4" class="text-right">
              <h5>TOTAL</h5>
            </td>
            <td class="text-right">
              <h5>{{ totals.quantity | decimalPlaces }}</h5>
            </td>
            <td class="text-right">
              <h5>{{ totals.total | lumCurrency }}</h5>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <mat-paginator
      [length]="ordersRecord.total"
      [pageSize]="ordersRecord.per_page"
      [pageSizeOptions]="pageSizeOptions"
      (page)="getRecords($event)"
      class="lum-paging lum-paging--dodge-back-to-top lum-paging--sticky"
    >
    </mat-paginator>
  </div>
</div>
